<template>
  <h1 class="text-white font-bold">CDS</h1>
</template>
<script setup></script>
